module.exports = __webpack_public_path__ + "img/bmcl_gallery14.3e489df7.jpg";